export const ApplicantOptionsKLI = [
  { label: "KLI Removal", value: "KLI Removal" },
];
